import { render, staticRenderFns } from "./ModalEvaluateDelivery.vue?vue&type=template&id=6c353d90&scoped=true&"
import script from "./ModalEvaluateDelivery.vue?vue&type=script&lang=js&"
export * from "./ModalEvaluateDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ModalEvaluateDelivery.vue?vue&type=style&index=0&id=6c353d90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c353d90",
  null
  
)

export default component.exports